import { SystemField } from "./system-field";

export class Shipment extends SystemField {
     
     invoices_id?:string;
     ship_to_id?:string;
     ship_by_id?:string;
     received_by_id?:string;
     ship_datetime?:string;
     status?:string;
     ship_num?:string;
     total_qty?:number;
}
